<template>
  <BaseCustomizeMetal componentCode="E" />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalE",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 78px;
    left: 139px;
    @include betweenTableTablePro {
      top: 47px;
      left: 89px;
    }
    @include table {
      top: 32px;
      left: 64px;
    }
    @include phone {
      top: 23px;
      left: 49px;
    }
  }
  .templeName {
    height: 33px;
    width: 163px;
    .textContainer {
      width: 163px;
    }
  }
  .godName {
    width: 189px;
    height: 55px;
    .textContainer {
      width: 189px;
    }
  }
  .gift {
    margin: 0 0 auto auto;
    width: 223px;
    height: 40px;
    .textContainer {
      width: 223px;
    }
  }
}
</style>
